// @ts-nocheck

export const VipRank = {
  UNRANKED: '',
  CHROME: 'Chrome',
  ALUMINIUM: 'Aluminium',
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
  PLATINUM: 'Platinum',
  DIAMOND1: 'Diamond *',
  DIAMOND2: 'Diamond **',
  DIAMOND3: 'Diamond ***',
  DIAMOND4: 'Diamond ****',
  DIAMOND5: 'Diamond *****',
  RED_DIAMOND: 'Red diamond',
};
